module.exports = PromiseQueue = Em.Object.extend Em.Evented,

  _initQueue: (->
    @set('queue', [])
  ).on('init')

  queue: null

  isEmpty: ->
    @get('queue').length <= 0

  push: (key, wrappedPromise) ->
    execPromise = (wp) =>
      wp().finally =>
        setTimeout =>
          @get('queue').shift()

          if @get('queue').length
            execPromise(@get('queue')[0].promise)
          else
            @trigger('empty')
        , 0

    if @get('queue').length <= 0
      @get('queue').push({ promise: wrappedPromise, key })
      execPromise(wrappedPromise)
    else
      if @get('queue').length > 1
        skip = _.takeRightWhile(@get('queue'), (el) -> el.key is key).length
        skip = skip - 1 if skip is @get('queue').length
        @get('queue').splice(-1, skip) if skip > 0

      @get('queue').push({ promise: wrappedPromise, key })
